module.exports = __webpack_public_path__ + "assets/minus-large.b9d6b97f.svg";